import { defineMessages } from "react-intl";

export const cookieConsentMessages = defineMessages({
  bannerTitle: {
    id: "cookieConsent.bannerTitle",
    defaultMessage: "Workspace cookie",
  },
  bannerDescription: {
    id: "cookieConsent.bannerDescription",
    defaultMessage:
      "We use one cookie to remember your workspace selection and keep you in the right workspace.",
  },
  acceptButton: {
    id: "cookieConsent.acceptButton",
    defaultMessage: "Allow cookie",
  },
});
